import type { FilterConfig } from '../types';
import { FILTER_TYPES } from '../constants/FilterTypes';

export class DataTableCriteriaModel {
    static decorate(criteria: any, filterConfig: FilterConfig[]): any {
        if (!criteria) return null;

        const cloned = JSON.parse(JSON.stringify(criteria));

        if (!cloned.filters) return cloned;

        Object.keys(cloned.filters).forEach(fieldName => {
            const filter = cloned.filters[fieldName];
            const config = filterConfig.find(c => c.fieldName === fieldName);

            if (!config) return;

            filter.apiParamName = config.apiParamName || fieldName;
            filter.apiValueConverter = config.apiValueConverter;
            filter.apiValueFromConverter = config.apiValueFromConverter;
            filter.apiValueToConverter = config.apiValueToConverter;

            if (!filter.apiValueConverter && filter.type === FILTER_TYPES.TEXT) {
                filter.value = DataTableCriteriaModel.normalizeFilterValue(filter.value);
            }
        });

        return cloned;
    }

    static withoutPagination(criteria: any): string {
        if (!criteria) return JSON.stringify(criteria);

        const cloned = { ...criteria };

        delete cloned.first;
        delete cloned.rows;
        delete cloned.sortField;
        delete cloned.sortOrder;

        return JSON.stringify(cloned);
    }

    private static normalizeFilterValue(value: any): string {
        if (Array.isArray(value)) {
            return value
                .map(item =>
                    item?.id ??
                    item?.label ??
                    item?.name ??
                    item
                )
                .filter(
                    item =>
                        item !== null &&
                        item !== undefined &&
                        item !== '',
                )
                .map(String)
                .join(',');
        }

        if (value && typeof value === 'object') {
            return String(
                value.id ??
                value.label ??
                value.name ??
                '',
            );
        }

        return value == null
            ? ''
            : String(value);
    }
}